import type { ButtonHTMLAttributes } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.css';

export interface BackButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'> {
  /** Navigation target: number for history navigation (e.g., -1), string for path */
  to?: number | string;
  /** Button label text */
  label?: string;
}

export function BackButton({
  to = -1,
  label = '戻る',
  onClick,
  ...rest
}: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      if (typeof to === 'number') {
        navigate(to);
      } else {
        navigate(to);
      }
    }
  };

  return (
    <button
      type="button"
      className={styles.backButton}
      onClick={handleClick}
      {...rest}
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        className={styles.icon}
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
      <span className={styles.label}>{label}</span>
    </button>
  );
}
